const COLUMNS_GROUPS = [
  {
    id: "name",
    label: "Name",
    widget: "text",
    width: 300
  }, {
    id: "companynam",
    label: "Company Name",
    widget: "text",
    width: 300
  }, {
    id: "email",
    label: "Email",
    widget: "text",
    width: 300
  },{
    id: "phone",
    label: "Work Phone",
    widget: "number",
    width: 100
  },{
    id: "amount",
    label: "payables",
    widget: "number",
    width: 100
  },  {
    id: "unusedcredits",
    label: "Unused Credits",
    widget: "number"
  }
];

const ROW_ACTIONS=[
  {
    name: "Rahul Sharma",
    companynam: "Sharma Enterprises",
    email: "rahul.sharma@sharmaenterprises.com",
    phone: "9876543210",
    amount: "45000",
    unusedcredits: "3500"
  },
  {
    name: "Priya Nair",
    companynam: "Nair Traders",
    email: "priya@nairtraders.in",
    phone: "9123456780",
    amount: "62000",
    unusedcredits: "1200"
  },
  {
    name: "Amit Verma",
    companynam: "Verma Solutions",
    email: "contact@vermasolutions.com",
    phone: "9012345678",
    amount: "28000",
    unusedcredits: "500"
  }
];


export {COLUMNS_GROUPS, ROW_ACTIONS};
